(function () {
  'use strict';
  if (window.ssHelmetJotform) {
    window.ssHelmetJotform.init(document);
    return;
  }
  var instances = new Map();
  function init(root) {
    if (instances.has(root)) return;
    var link = root.querySelector('[data-helmet-external]');
    var host = root.querySelector('[data-helmet-frame]');
    var loading = root.querySelector('[data-helmet-loading]');
    var error = root.querySelector('[data-helmet-error]');
    if (!link || !host || !loading || !error) return;
    var url;
    try { url = new URL(link.href); } catch (_) { return; }
    if (url.origin !== 'https://form.jotform.com' || !/^\/\d+$/.test(url.pathname)) return;
    var frame = null;
    var timer = null;
    var observer = null;
    var aborter = new AbortController();
    function delayed() {
      loading.hidden = true;
      error.hidden = false;
      host.setAttribute('aria-busy', 'false');
    }
    function receive(event) {
      if (!frame || event.source !== frame.contentWindow || event.origin !== url.origin) return;
      var match = typeof event.data === 'string' && event.data.match(/^setHeight:(\d+)(?::|$)/);
      if (!match) return;
      var height = Number(match[1]);
      if (!Number.isFinite(height) || height < 400 || height > 12000) return;
      frame.style.height = height + 'px';
      loading.hidden = true;
      error.hidden = true;
      host.setAttribute('aria-busy', 'false');
      window.clearTimeout(timer);
    }
    function load() {
      if (frame) return;
      if (observer) observer.disconnect();
      frame = document.createElement('iframe');
      frame.id = root.id + '-frame';
      frame.title = host.dataset.title;
      frame.loading = 'lazy';
      frame.referrerPolicy = 'no-referrer';
      frame.style.height = '1100px';
      loading.hidden = false;
      error.hidden = true;
      host.setAttribute('aria-busy', 'true');
      frame.addEventListener('load', function () {
        loading.hidden = true;
        host.setAttribute('aria-busy', 'false');
      }, { signal: aborter.signal });
      frame.addEventListener('error', delayed, { signal: aborter.signal });
      timer = window.setTimeout(delayed, 16000);
      frame.src = url.href;
      host.appendChild(frame);
    }
    function hashLoad() {
      if (window.location.hash === '#' + root.id) load();
    }
    function clickLoad(event) {
      var anchor = event.target.closest && event.target.closest('a[href]');
      if (!anchor) return;
      var destination;
      try { destination = new URL(anchor.href, window.location.href); } catch (_) { return; }
      if (destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.hash === '#' + root.id) load();
    }
    function destroy() {
      if (observer) observer.disconnect();
      window.clearTimeout(timer);
      aborter.abort();
      instances.delete(root);
    }
    instances.set(root, { destroy: destroy });
    window.addEventListener('message', receive, { signal: aborter.signal });
    window.addEventListener('hashchange', hashLoad, { signal: aborter.signal });
    document.addEventListener('click', clickLoad, { signal: aborter.signal });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) load();
      }, { rootMargin: '700px' });
      observer.observe(root);
    } else {
      load();
    }
    hashLoad();
  }
  function start(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('[data-ss-helmet-jotform]')) init(scope);
    scope.querySelectorAll('[data-ss-helmet-jotform]').forEach(init);
  }
  window.ssHelmetJotform = { init: start };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(document); }, { once: true });
  else start(document);
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (state, root) {
      if (event.target === root || event.target.contains(root)) state.destroy();
    });
  });
})();
